import { Tba } from '../tba';
import { TbaRangeType } from '../tba-range-type';

export class DefineRangeTypeModalPayload {
  tba: Tba;
  rangeType: TbaRangeType;
  taxSource: string;
  taxDestination: string;
}
